// Orquestração de "trocar para uma marca" no front, isolada da UI para ser
// testável. Regra: se o diretor ainda não é membro da marca, cria o acesso
// (join) ANTES de defini-la como ativa — senão o setActive falharia por falta de
// filiação. Marca em que já é membro só é ativada.
//
// As dependências (joinBrand, setActive) são injetadas para o teste não precisar
// de rede nem do authClient real.

import { authErrorMessage } from "@/lib/auth-errors";
import i18n from "./i18n.js";

export interface SwitchToBrandDeps {
  joinBrand: (organizationId: string) => Promise<unknown>;
  setActive: (organizationId: string) => Promise<{ error?: { message?: string } | null }>;
}

export async function switchToBrand(
  brand: { id: string; isMember: boolean },
  deps: SwitchToBrandDeps,
): Promise<void> {
  if (!brand.isMember) {
    await deps.joinBrand(brand.id);
  }
  const { error } = await deps.setActive(brand.id);
  if (error) {
    throw new Error(authErrorMessage(error, i18n.t("brandSwitch.error")));
  }
}
